<template>
    <div class="menu-management">
        <div class="menuTop">
            <el-button type="primary"  @click="addRootDirectory('1')">新增根目录</el-button>
            <el-button type="primary"  :disabled="nodeData&&nodeData.id?false:true" @click="addRootDirectory('2')">新增资源</el-button>
            <el-button type="primary"  :disabled="nodeData&&nodeData.id?false:true" @click="upDataNode">修改</el-button>
            <el-button type="primary"  :disabled="nodeData&&nodeData.id?false:true" @click="delNode">删除</el-button>
        </div>
        <el-tree accordion :data="nodData" :props="defaultProps" 
         :default-expand-all="false" :default-expanded-keys="[0]" node-key="id" :highlight-current="true"
          @node-click="handleNodeClick"></el-tree>
        <el-dialog
                :close-on-click-modal="false" :close-on-press-escape="false"
                :title="title"
                :visible.sync="dialogVisible"
                width="500px"
                :before-close="handleClose">
            <el-form :model="catalogue" :rules="rules" ref="catalogue" label-width="130px" class="demo-ruleForm">
                <el-form-item label="资源名称" prop="name">
                    <el-input placeholder="请输入资源名称" v-model="catalogue.name"></el-input>
                </el-form-item>
                <el-form-item label="资源路径" prop="code">
                    <el-input  placeholder="请输入资源路径" v-model="catalogue.code"></el-input>
                </el-form-item>
                <el-form-item label="apiURL" prop="uri">
                    <el-input placeholder="请输入apiURL" v-model="catalogue.uri"></el-input>
                </el-form-item>
                <el-form-item label="icon" prop="icon">
                    <el-input  placeholder="请输入icon图标" v-model="catalogue.icon"></el-input>
                </el-form-item>
                <el-form-item label="是否是按钮资源" prop="isButton">
                    <el-switch  v-model="catalogue.isButton" active-color="#13ce66"  inactive-color="#ff4949"> </el-switch>
                </el-form-item>
                <el-form-item label="是否区域授权资源" prop="isRegionalAuth">
                    <el-switch :disabled="isEdit" v-model="catalogue.isRegionalAuth" active-color="#13ce66"  inactive-color="#ff4949"> </el-switch>
                </el-form-item>
                <el-form-item label="是否本系统资源" prop="isThisSystem">
                    <el-switch  v-model="catalogue.isThisSystem" active-color="#13ce66"  inactive-color="#ff4949"> </el-switch>
                </el-form-item>
                <el-form-item label="当前资源顺序" prop="indexNum">
                    <el-input-number  v-model="catalogue.indexNum" :min="1" :max="99" label="当前资源顺序"></el-input-number>
                </el-form-item>

            </el-form>
             <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose">取 消</el-button>
                <el-button type="primary" @click="submitForm('catalogue')">确 定</el-button>
              </span>
        </el-dialog>
    </div>
</template>

<script>
    import {systemApi} from '../../../../api-path/system-api'

    export default {
        name: "menu-management",
        data(){
          return{
              dialogVisible:false,
              treeClickCount: 0,//定义点击次数,默认0次
              timer:null,
              title:'',
              nodData: [],
              defaultProps: { //tree结构
                  children: 'sourceTreeDTOList',
                  label: 'name'
              },
              nodeData:{},
              catalogue:{//目录
                  indexNum:1,//顺序
                  name:'',//当前资源名称
                  code:'',//路由地址
                  uri:'',//api路径
                  isRegionalAuth:false,//是否区域授权资源
                  isButton:false,//是否按钮
                  isThisSystem:true,
                  icon:'',//图标
                  parentId:'',
              },
              rules:{
                  name:[{ required: true, message: '请输入资源名称', trigger: 'blur' }   ],
                  code:[{ required: true, message: '请输入资源路径或者按钮标识', trigger: 'blur' }],
                  // uri:[{ required: true, message: '请输入apiURL', trigger: 'blur' }],
              },
			  isEdit:false
          }
        },
        created() {
            this.resourceTree()
        },

        methods:{
            resourceTree(){
                this.$http.get(systemApi.resourceTree).then(res=>{
                    if(res.status==200){
                        this.nodData=res.result;
                        this.nodeData={};
                    }
                })
            },
            handleNodeClick(data){
                //记录点击次数
                this.treeClickCount++;
                //单次点击次数超过2次不作处理,直接返回,也可以拓展成多击事件
                if (this.treeClickCount >= 2) {
                    return;
                }
                //计时器,计算300毫秒为单位,可自行修改
                this.timer = window.setTimeout(() => {
                    if (this.treeClickCount == 1) {   //单击事件
                        this.treeClickCount = 0;
                        this.nodeData=data;
                    } else if (this.treeClickCount > 1) {  //双击事件
                        this.treeClickCount = 0;
                        this.nodeData=data;
                        this.upDataNode(2)
                    }
                }, 300);

            },
            addRootDirectory(inx){ //新增根目录
                if(inx==1){ //如果为新增根目录清楚id;
                    this.nodeData.nodeId='';
                    this.title='添加根节点信息';
                    this.catalogue.parentId=0;
                }else {
                    this.catalogue.parentId=this.nodeData.id
                    this.title='添加节点信息';
                }
                this.dialogVisible=true;
            },
            upDataNode(){//修改节点
                this.title='修改节点信息';
                this.dialogVisible=true;
				if(this.nodeData.isRegionalAuth){
					this.isEdit=true;
				}
                this.catalogue={//目录
                        indexNum:this.nodeData.indexNum,//顺序
                        name:this.nodeData.name,//当前资源名称
                        code:this.nodeData.code,//路由地址
                        uri:this.nodeData.uri,//api路径
                        isRegionalAuth:this.nodeData.isRegionalAuth,//是否区域授权资源
                        isButton:this.nodeData.isButton,//是否按钮
                        icon:this.nodeData.icon,//图标
                        isThisSystem:this.nodeData.isThisSystem,
                        id:this.nodeData.id,
                        parentId:this.nodeData.parentId
                };
            },
            delNode(){//删除节点
                this.$confirm('此操作将永久删除该资源, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$http.delete(systemApi.deleteResource,{params:{id:this.nodeData.id}}).then(res=>{
                        if(res.status==200){
                            this.$message.success('删除资源成功')
                            this.resourceTree()
                        }
                    })
                }).catch(() => {});
            },

            handleClose(){
                let $this=this;
                // $this.nodeData={}
                $this.title='';
                $this.catalogue = {
                    indexNum:1,//顺序
                    name:'',//当前资源名称
                    code:'',//路由地址
                    uri:'',//api路径
                    isRegionalAuth:false,//是否区域授权资源
                    isButton:false,//是否按钮
                    isThisSystem:true,
                    icon:'',//图标
                    parentId:'',
                }
                $this.dialogVisible=false;
				this.isEdit=false;

            },
            submitForm(formName){
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                       this.$http.post(systemApi.saveResource,this.catalogue).then(res=>{
                           if(res.status==200){
                               this.dialogVisible=false;
                               this.resourceTree();
                               this.handleClose();
                           }
                       })
                    } else {
                        return false;
                    }
                });
            }

        }
    }
</script>

<style scoped lang="less">
   .menu-management{
       height: 100%;
       background: #fff;
       margin-left: 10px;
	   display: flex;
	   flex-direction: column;
       .menuTop{
         padding-top: 10px;
         margin:0 0 10px 10px;
       }
	   .el-tree{
		   flex: 1;
		   overflow-y: auto;
	   }
       .el-input-number{
         width: inherit;
         line-height: 31px;
       }
   }
</style>